import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AisRestService, ConditionDisclosureResource, DisclosureSource, InterviewDisclosureIdentifier } from '@Components/mras/core';

@Component({
    selector: 'jhi-question-unknown',
    templateUrl: './question-unknown.component.html',
    styles: []
})
export class QuestionUnknownComponent implements OnInit {
    readonly DisclosureSource = DisclosureSource;

    @Input()
        summaryMode: boolean;
    @Input()
        disclosureSource: DisclosureSource;

    @Input()
        disclosureIdentifier: InterviewDisclosureIdentifier;
    @Input()
        disclosure: ConditionDisclosureResource;
    @Output()
        disclosureChange = new EventEmitter<ConditionDisclosureResource>();
    @Output()
        onRemove = new EventEmitter<string>();
    @Input()
        showDisclosureName: boolean;

    disclosureName: string;
    httpErrorMsg: string;
    note: string;

    constructor(private aisRestService: AisRestService) {}

    ngOnInit(): void {
        this.disclosureName = this.disclosure.aliasName;
        this.note = this.disclosure.note;
    }

    answerUnknownQuestion() {
        this.httpErrorMsg = null;
        const resource = new ConditionDisclosureResource();
        resource.note = this.disclosure.note;
        this.aisRestService.answerReflexiveQuestion(this.disclosureIdentifier, resource).subscribe(
            answerReflexiveQuestionResp => {
                Object.keys(this.disclosure).forEach(f => delete this.disclosure[f]);
                Object.assign(this.disclosure, answerReflexiveQuestionResp);
                this.disclosureChange.emit(this.disclosure);
            },
            errMsg => (this.httpErrorMsg = errMsg)
        );
    }

    onRemoveClick() {
        this.onRemove.emit(this.disclosureName);
    }

    isRemovable(): boolean {
        if (
            this.disclosure.removableFromBqCodes == null ||
            this.disclosure.removableFromBqCodes.length == 0 ||
            this.disclosureSource !== DisclosureSource.SEARCH
        ) {
            return false;
        }
        return this.disclosure.removableFromBqCodes.indexOf(this.disclosureIdentifier.baseQuestionCode) > -1;
    }
}
